import React from 'react';
import { TextInput, DropdownSelector } from 'hyperdb-utils';
import api from 'api';
import { DEFAULT_LANGUAGE } from '../../../../../config';

class CountrySelector extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.api.country.getObjects({
      propName: 'countries',
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  render() {
    return (
      <DropdownSelector
        label={ `Country ${ this.props.required ? ' *' : '' }` }
        name="country"
        value={ this.props.value }
        options={ this.countriesOptions(this.props.countries) }
        onChange={ this.props.onChange }
      />
    );
  }
  countriesOptions(countries) {
    if (!countries) return [];
    return countries.map(c => ({ name: (c.name.$i18n || {})[DEFAULT_LANGUAGE], value: c.id }));
  }
}

CountrySelector.propTypes = {
  api: React.PropTypes.object,
  value: React.PropTypes.string,
  countries: React.PropTypes.array,
  onChange: React.PropTypes.func,
};

export default api.connect(CountrySelector, 'country');



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/country/containers/CountrySelector.jsx